"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UIDialogHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      use = _ref.use,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "use"]);
  return _react.default.createElement("header", (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)('private-modal__header', 'uiDialogHeader', className, {
      'private-modal__header--with-toolbar': use === 'toolbar'
    })
  }), _react.default.createElement("div", {
    className: "private-modal__header__inner"
  }, children));
}

UIDialogHeader.propTypes = {
  children: _react.PropTypes.node,
  use: _react.PropTypes.oneOf(['default', 'toolbar'])
};
UIDialogHeader.displayName = 'UIDialogHeader';
module.exports = exports.default;